import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { isTeacherPaywallEnabled } from "./appConfig";

export const handleApiError = (error: AxiosError): Promise<never> => {
  const defaultErrorMessage = "An unexpected error occurred";
  let errorMessage = defaultErrorMessage;

  if (error.response && error.response.data) {
    const responseData = error.response.data as {
      detail?: string;
      non_field_errors?: string[];
      message?: string;
      data?: string | { [key: string]: any };
      [key: string]: any;
    };

    if (typeof responseData.data === "string") {
      errorMessage = responseData.data;
      if (responseData.data === "Invalid or expired token.") {
        localStorage.removeItem("teacher-portal");
        window.location.href = "/login?logout=true";
      } else if (
        responseData.data === "Please add Subscription to Apply." &&
        isTeacherPaywallEnabled()
      ) {
        window.location.href = "/dashboard/pricing";
      }
    } else if (responseData.detail) {
      errorMessage = responseData.detail;
    } else if (responseData.message && responseData.data && typeof responseData.data !== "string") {
      errorMessage = String(responseData.data);
    } else if (Array.isArray(responseData.non_field_errors)) {
      errorMessage = responseData.non_field_errors[0];
    } else if (typeof error.response.data === "string") {
      errorMessage = error.response.data;
    } else if (typeof responseData.message === "string") {
      errorMessage = responseData.message;
    } else {
      const fieldErrors = Object.keys(responseData)
        .map((key) => {
          if (Array.isArray(responseData[key])) {
            return `${key}: ${responseData[key].join(", ")}`;
          }
          return null;
        })
        .filter((msg) => msg !== null);

      if (fieldErrors.length > 0) {
        errorMessage = fieldErrors.join("; ");
      }
    }
  }

  if (errorMessage.includes("535") || errorMessage.toLowerCase().includes("authentication rejected")) {
    errorMessage = "We could not send the email right now. Please try again later or contact connect@gulfteachers.com.";
  }

  toast.error(errorMessage, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  return Promise.reject(error);
};
